<template>
    <div>
        <div class="card" style="height:600px!important">
            <div id="loadingmessage"
                style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
                v-if="loading">
                <p style="position: absolute; color: White; top: 40%; left: 50%;">
                    <img src="../../assets/loader.gif" />
                </p>
            </div>
            <div class="listing-section pt-3 pl-3">
                <h3 class="listing-desc-headline margin-top-60" style="font-weight:400!important;margin-bottom:30px">
                    Sightings Location</h3>
                <div id="myMap"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    var marker
    export default {
        props: ['id'],
        data() {
            return {
                loading: false,
                location: [],
            }
        },
        mounted: function () {
            this.getList()
        },

        methods: {
            getList() {
                this.loading = true
                var att = {}

                att['token'] = localStorage.getItem('token')
                axios({
                    method: 'GET',
                    url: '/rescue/get/?id=' + this.id,
                    data: att,
                })
                    .then(response => {
                        // console.log(response.data.data)

                        this.loading = false
                        if (response.data.status === true) {
                            this.location = response.data.data.location

                            var mapCanvas = document.getElementById('myMap')
                            var mapOptions = {
                                // eslint-disable-next-line
                                center: new google.maps.LatLng(this.location[1], this.location[0]),
                                zoom: 9,
                                // eslint-disable-next-line
                                mapTypeId: google.maps.MapTypeId.TERRAUN
                            }
                            var vm = this
                            // eslint-disable-next-line
                            vm.map = new google.maps.Map(mapCanvas, mapOptions);
                            var latlngset = new google.maps.LatLng(
                                this.location[1],
                                this.location[0]
                            )

                            // var iconBase = 'http://maps.google.com/mapfiles/kml/pal4/icon52.png'
                            marker = new google.maps.Marker({
                                map: vm.map,
                                position: latlngset,
                            })
                            // console.log(msrker);
                            var contentString =
                                '<table><tr><td colspan=2 style="padding-left:10px;"><p style="font-size:14px;color:#333333;font-weight:500"><b>Name: ' +
                                this.name +
                                '</b></p></td></tr></table>'

                            var infowindow = new google.maps.InfoWindow({
                                content: contentString,
                            })
                            marker.addListener('click', function () {
                                infowindow.open(vm.map, marker)
                            })
                        } else if (response.data.status === false) {
                            this.loading = false
                        }
                    })
                    .catch(e => {
                        console.log(e)
                        this.loading = false
                        // this.errors.push(e)
                        // this.msg = 'failed'
                    })
            },
        },
    }
</script>
<style>
    #myMap {
        height: 500px !important;
        width: 100%;
    }
</style>